export const pageview = (url) => {
  if (window && window.gtag) {
    window.gtag("config", "G-4HHCJ2S9BT", {
      page_path: url,
    });
  }
};

export const event = ({ action, params }) => {
  window.gtag("event", action, params);
};
